import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "data-table__value" };
const _hoisted_2 = ["title"];
import { computed, inject } from 'vue';
import { RouterLink } from "vue-router";
import { DATA_TABLE_CONTEXT } from "./context";
import DataTableSlotOutlet from "./DataTableSlotOutlet";
import DataTableCell from "./DataTableCell.vue";
import Icon from "../Icon.vue";
/**
 * A row of the table (right, scrollable) part of the data table: one cell
 * per selected column plus the row actions.
 */
export default /*@__PURE__*/ _defineComponent({
    __name: 'DataTableRow',
    props: {
        item: {}
    },
    setup(__props) {
        const props = __props;
        const ctx = inject(DATA_TABLE_CONTEXT);
        const hover = computed(() => ctx.hoveredItemId.value === props.item.id);
        const active = computed(() => ctx.activeItemId.value === props.item.id);
        const favourite = computed(() => {
            ctx.favouritesVersion.value; // re-evaluate when favourites change
            return ctx.isFavourite(props.item);
        });
        const rowClass = computed(() => ({
            'data-table__row--hover': hover.value,
            'data-table__row--active': active.value,
            ['data-table__row--status-' + props.item.status]: true,
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(ctx).itemRoute.value ? _unref(RouterLink) : 'div'), {
                to: _unref(ctx).itemRoute.value ? _unref(ctx).createItemRoute(__props.item) : null,
                class: _normalizeClass(["data-table__row", rowClass.value]),
                onMouseover: _cache[2] || (_cache[2] = ($event) => (_unref(ctx).setHovered(__props.item.id))),
                onClick: _cache[3] || (_cache[3] = ($event) => (_unref(ctx).itemRoute.value || _unref(ctx).activate(__props.item)))
            }, {
                default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ctx).columnViews.value, (view) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: view.column.name,
                            class: _normalizeClass(view.cellClass)
                        }, [
                            _createVNode(_unref(DataTableSlotOutlet), {
                                slots: _unref(ctx).slots,
                                name: view.cellSlotName,
                                scope: { item: __props.item }
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_1, [
                                        _createVNode(DataTableCell, {
                                            value: __props.item.attributes[view.column.name],
                                            type: view.column.dataType,
                                            "show-nulls": _unref(ctx).showNulls.value,
                                            item: __props.item,
                                            column: view.column,
                                            "translation-prefix": view.translationPrefix
                                        }, null, 8, ["value", "type", "show-nulls", "item", "column", "translation-prefix"])
                                    ])
                                ]),
                                _: 2
                            }, 1032, ["slots", "name", "scope"])
                        ], 2));
                    }), 128)),
                    _cache[5] || (_cache[5] = _createTextVNode()),
                    _createElementVNode("div", {
                        onClick: _cache[1] || (_cache[1] = _withModifiers(() => { }, ["stop"])),
                        class: "data-table__row-actions"
                    }, [
                        _createVNode(_unref(DataTableSlotOutlet), {
                            slots: _unref(ctx).slots,
                            name: "item-actions",
                            scope: { item: __props.item }
                        }, null, 8, ["slots", "scope"]),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        (_unref(ctx).capabilities.value.favourites)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_unref(ctx).toggleFavourite(__props.item)), ["prevent"])),
                                class: "button button--icon button--link",
                                href: "",
                                title: _ctx.$t('data_table.toggle_favourite')
                            }, [
                                _createVNode(Icon, {
                                    name: "star",
                                    "icon-style": favourite.value ? 'solid' : 'regular'
                                }, null, 8, ["icon-style"])
                            ], 8, _hoisted_2))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _: 1
            }, 40, ["to", "class"]));
        };
    }
});
